import { PageHero, Container, SectionHead, CtaBand } from "@/components/site/blocks";
import { Reveal } from "@/components/site/motion";
import { useSeo } from "@/components/site/useSeo";

const AUDIENCES = [
  "Vocational rehabilitation clients", "Transition and Pre-ETS students", "Youth ages 14–22", "Families and caregivers",
  "VR professionals", "Educators", "Centers for Independent Living", "Community providers", "Employers",
];
const COLLEGE = ["Disability Services", "Student Affairs", "Social work", "Psychology", "Rehabilitation", "Theology", "African American Studies", "Film / media", "Campus ministry"];

export default function Serves() {
  useSeo("Who It Serves", "JEM serves VR clients, transition and Pre-ETS students, youth 14–22, families, VR professionals, educators, CILs, community providers, employers, and colleges.");
  return (
    <>
      <PageHero testid="serves-hero" label="Who It Serves" lines={["Built for people", <span key="m" className="italic text-[#F3C649]">on the move.</span>]}
        intro="JEM speaks to people shaping their own future, and to the professionals and families who walk alongside them." />
      <section className="pb-24" data-testid="serves-audiences">
        <Container className="grid gap-5 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="relative h-full min-h-[380px] overflow-hidden rounded-3xl border border-[#D4AF37]/25">
              <img src="/images/friends.jpg" alt="Three friends laughing together, one using a wheelchair, sharing a snack outdoors" className="absolute inset-0 h-full w-full object-cover" />
            </div>
          </Reveal>
          <ul className="grid gap-px overflow-hidden rounded-3xl border border-[#D4AF37]/25 bg-[#D4AF37]/25 sm:grid-cols-2 lg:col-span-7">
            {AUDIENCES.map((a, i) => (
              <li key={a} className="group flex items-start gap-4 bg-[#12141C] p-6 transition-colors duration-500 hover:bg-[#181A24]" data-testid={`audience-${i}`}>
                <span className="font-mono-label text-xs text-[#F3C649]">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display text-2xl leading-tight">{a}</span>
              </li>
            ))}
            <li className="bg-[#12141C] p-6 text-sm text-[#C8C5BB]">…and others who share these goals.</li>
          </ul>
        </Container>
      </section>
      <section className="bg-[#07080A] py-24 sm:py-32" data-testid="serves-college">
        <Container className="grid gap-14 lg:grid-cols-12">
          <SectionHead className="lg:col-span-5" label="Colleges & universities" title="A fit across campus."
            intro="Possible college audiences and departments include:" />
          <ul className="flex flex-wrap content-start gap-3 lg:col-span-7">
            {COLLEGE.map((c, i) => (
              <Reveal key={c} delay={i * 0.04} y={14}>
                <li className="rounded-full border border-[#D4AF37]/40 px-5 py-3 text-base text-[#F9F8F6] transition-colors duration-300 hover:bg-[#F3C649] hover:text-[#0A0B0E]">{c}</li>
              </Reveal>
            ))}
          </ul>
        </Container>
      </section>
      <CtaBand />
    </>
  );
}
